const steps = [
    { number: 1, label: "Ustal cel" },
    { number: 2, label: "Wybierz plan" },
    { number: 3, label: "Zacznij działać" },
  ];
  
  const StepBoxes = () => {
    return (
      <div className="relative z-20 -mt-14 mb-12 px-4">
        <div className="flex flex-col md:flex-row justify-center gap-8 max-w-5xl mx-auto">
          {steps.map((step, idx) => (
            <div
              key={idx}
              className="relative bg-brandDark bg-opacity-95 text-brandLight px-6 py-6 w-full md:w-[220px] h-32 transform skew-x-[-12deg] shadow-lg flex items-center justify-center"
            >
              {/* Numer */}
              <div className="absolute top-2 left-3 text-brandGreen text-lg font-bold transform skew-x-[12deg]">
                {step.number < 10 ? `0${step.number}.` : step.number}
              </div>
  
              {/* Tekst główny */}
              <div className="text-xl font-semibold transform skew-x-[12deg] text-center">
                {step.label}
              </div>
  
              {/* Strzałki */}
              <div className="absolute bottom-2 right-3 transform skew-x-[12deg]">
                <svg
                  className="w-6 h-6 text-brandGreen"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13 5l7 7-7 7" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4 5l7 7-7 7" />
                </svg>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };
  
  export default StepBoxes;
  